<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 订单记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="数据范围">
          <el-select
            v-model="unmannedApiType"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单类型"
          >
            <el-option label="选中门店" value=""></el-option>
            <el-option label="全部门店" value="allStore"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店仓库" v-if="unmannedApiType != 'allStore'">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            v-model="formInline.dataType"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单类型"
          >
            <el-option label="未完成" value="none"></el-option>
            <el-option label="未出库" value="uninventory"></el-option>
            <el-option label="已完成" value="done"></el-option>
            <el-option label="已取消" value="cancel"></el-option>
            <el-option label="全部" value="all"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            style="width: 240px"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div
        style="padding: 10px; background-color: #ffffff"
        v-if="unmannedApiType != 'allStore' && !!storeGuid"
      >
        <el-button type="primary" @click="createOrderClick"> 创建订单 </el-button>
        <el-button
          :loading="voicePlayLoading"
          type="default"
          @click="voicePlayClick(nulll)"
        >
          播放引导语音
        </el-button>
        <el-button :loading="openDoorLoading" type="default" @click="openDoorClick">
          远程开门
        </el-button>
      </div>
      <div style="padding: 10px">
        <time-range @change="handleTimeChange" v-if="formInline.dataType != 'none'">
          <template slot="append">
            <!-- <div style="margin-right: 10px">
              <el-button type="default" @click="exportClick"> 导出记录 </el-button>
            </div> -->
          </template>
        </time-range>
        <div v-if="!!times || formInline.dataType == 'none'">
          <x-table
            ref="list"
            listApi="biz.warehouse.order.info.list"
            paginationLayout="total, sizes, prev, next, jumper"
            defaultSort="order_time desc"
            actionFixed="right"
            emptyLabel="暂无订单信息"
            :fieldList="fieldList"
            :actionList="actionList"
            :defaultParams="defaultParams"
            :actionWidth="280"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-order-info
                :showCount="true"
                :orderInfo="scope.row"
                :showStatus="scope.row.customerGuid != '1236952854388871168'"
                @inventoryListClick="inventoryListClick"
                @paymentListClick="paymentListClick"
                @prescriptionListClick="prescriptionListClick"
                @refundListClick="refundListClick"
              >
                <template slot="append">
                  <x-upload
                    type="image"
                    imageAlign="start"
                    v-if="!!scope.row.riderPickingPhoto"
                    :fileCount="4"
                    :fileSize="10 * 1024"
                    :imageViewWidth="180"
                    :imageViewHeight="180"
                    :disabled="true"
                    :value="scope.row.riderPickingPhoto.split(',').join('|')"
                  ></x-upload>
                </template>
              </warehouse-order-info>
            </template>
          </x-table>
        </div>
        <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
      </div>
    </el-card>
    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="printLoading"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在打印中
      </span>
    </el-dialog>
  </div>
</template>

<script>
import timeRange from "../../../../components/timeRange.vue";
import warehouseOrderInfo from "../../../../components/business/warehouseOrderInfoByChannel.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import customerOrderChannelSelect from "../../../../components/business/customerOrderChannelSelect.vue";
import orderDetail from "./detail.vue";
import orderPayment from "./__payment.vue";
import orderCreate from "./__recreate.vue";
import orderFromPage from "./__order_form.vue";

export default {
  components: {
    timeRange,
    warehouseOrderInfo,
    customerStoreSelect,
    customerOrderChannelSelect,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        this.unmannedApiType == "allStore"
          ? {
              orderTypeIn: ["channel", "unmanned"],
              noStore: 1,
            }
          : {
              orderTypeIn: ["channel", "unmanned"],
              storeGuid: this.storeGuid,
            },
        this.formInline.dataType == "none"
          ? {
              channelOrderStatusIn: [0, 3],
            }
          : Object.assign(
              this.formInline.dataType == "done"
                ? {
                    channelOrderStatusIn: [2],
                  }
                : this.formInline.dataType == "cancel"
                ? {
                    channelOrderStatusIn: [1],
                  }
                : this.formInline.dataType == "uninventory"
                ? {
                    channelOrderStatusIn: [2],
                    optStatusIn: [2],
                  }
                : {},
              this.times
            ),
        this.queryModel || {}
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    voicePlayClick(row) {
      if (this.unmannedApiType == "allStore" || !this.storeGuid) {
        return;
      }
      this.voicePlayLoading = true;
      this.requestApi(
        "biz.customer.store.info.voicePlay",
        {
          storeGuid: this.storeGuid,
          voiceScene: "help_guide",
        },
        { showError: true }
      )
        .then(() => {
          this.success("已发送播放引导音频接口请求");
        })
        .finally(() => {
          this.voicePlayLoading = false;
        });
    },
    voicePlayClick(row) {
      if (this.unmannedApiType == "allStore" || !this.storeGuid) {
        return;
      }
      this.voicePlayLoading = true;
      this.requestApi(
        "biz.customer.store.info.voicePlay",
        {
          orderGuid: row ? row.guid : null,
          storeGuid: row ? row.storeGuid : this.storeGuid,
          voiceScene: row ? null : "help_guide",
        },
        { showError: true }
      )
        .then(() => {
          this.success("已发送播放引导音频接口请求");
        })
        .finally(() => {
          this.voicePlayLoading = false;
        });
    },
    openDoorClick() {
      if (this.unmannedApiType == "allStore" || !this.storeGuid) {
        return;
      }
      this.openDoorLoading = true;
      this.requestApi(
        "biz.customer.store.info.openDoor",
        {
          guid: this.storeGuid,
        },
        { showError: true }
      )
        .then(() => {
          this.success("已提交开门接口请求");
        })
        .finally(() => {
          this.openDoorLoading = false;
        });
    },
    createOrderClick() {
      if (this.unmannedApiType == "allStore" || !this.storeGuid) {
        return;
      }
      this.$drawer.openDrawer({
        title: "创建新订单",
        refresh: this.refresh,
        component: orderCreate,
        params: {
          storeGuid: this.storeGuid,
        },
      });
    },
    clearClick() {
      this.formInline = {
        dataType: "none",
        queryValue: "",
        optCancel: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    handleTimeChange(time) {
      this.times = time;
    },
    openDetailPage(row, tabName) {
      this.$drawer.openDrawer({
        title: "销售订单详细信息",
        refresh: this.refresh,
        component: orderDetail,
        params: {
          guid: row.guid,
          storeGuid: row.storeGuid,
          tabName: tabName,
        },
      });
    },
    inventoryListClick(row) {
      this.openDetailPage(row, "order-inventory");
    },
    paymentListClick(row) {
      this.openDetailPage(row, "order-payment");
    },
    refundListClick(row) {
      this.openDetailPage(row, "order-refund");
    },
    prescriptionListClick(row) {
      this.openDetailPage(row, "order-prescription");
    },
    handleChangeTagLabel(value, row) {
      this.requestApi(
        "biz.warehouse.order.info.setTagLabel",
        {
          guid: row.guid,
          storeGuid: row.storeGuid,
          tagLabel: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
  },
  data() {
    return {
      times: null,
      printLoading: false,
      voicePlayLoading: false,
      openDoorLoading: false,
      storeGuid: "",
      unmannedApiType: "allStore",
      queryModel: {},
      formInline: {
        dataType: "none",
        queryValue: "",
        optCancel: "",
      },
      fieldList: [
        {
          label: "订单信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.openDetailPage(row);
          },
        },
        {
          label: "播报",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.voicePlayClick(row);
          },
        },
        {
          label: "编辑",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "编辑订单信息",
              refresh: this.refresh,
              component: orderFromPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
      ],
    };
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
    unmannedApiType() {
      this.commitState({ unmannedApiType: this.unmannedApiType });
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.unmannedApiType = this.readState("unmannedApiType", "allStore");
  },
};
</script>
